
<div class="login-wrapper">

  <mat-card appearance="outlined" class="box">
    <mat-card-header>

      <img mat-card-image src="../../assets/img/CIMSUP_logo_500x150.png" alt="Cimsup CAB" class="cim-logo">

    </mat-card-header>

    <form class="example-form" #loginForm="ngForm">
      <mat-card-content>
        <mat-form-field class="cim-form-field-white"  [subscriptSizing]="'dynamic'">
          <mat-label>Base</mat-label>
          <input matInput placeholder="Base" id="Base" name="Base"  [(ngModel)]="base" required>
          <mat-icon matSuffix>cloud</mat-icon>
        </mat-form-field>
        <mat-form-field class="cim-form-field-white"  [subscriptSizing]="'dynamic'">
          <mat-label>Site</mat-label>
          <input matInput placeholder="Site" id="Site" name="Site" [(ngModel)]="site" required>
          <mat-icon matSuffix>house</mat-icon>
        </mat-form-field>
        <mat-form-field class="cim-form-field-white"  [subscriptSizing]="'dynamic'">
          <mat-label>User</mat-label>
          <input matInput placeholder="Utilisateur" id="Utilisateur" name="Utilisateur" [(ngModel)]="user" required>
          <mat-icon matSuffix>person</mat-icon>
        </mat-form-field>
        <mat-form-field class="cim-form-field-white"  [subscriptSizing]="'dynamic'">
          <mat-label>Password</mat-label>
          <input matInput type="password" placeholder="Password" id="password" name="password" ngModel>
          <mat-icon matSuffix>lock_open</mat-icon>
        </mat-form-field>
      </mat-card-content>
      <button cdkFocusInitial mat-stroked-button color="accent" class="btn-block" (click)="login(loginForm)">Connexion</button>
      @if (error) {
        <div class="alert alert-danger">{{error}}</div>
      }
    </form>
  </mat-card>

</div>
